/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Breadcrumb from "../../../component/breadcrumb";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import { withTranslation } from "react-i18next";
import { Grid, ButtonGroup } from "@mui/material";
import { UsersIcon, DetailView, ListView } from "../../../component/icons/icons";
import Button from "../../../component/button";
import { withNavigation } from "../../../helper/withNavigation";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import AddonsTable from "./addonsTable";
import Loader from "../../../component/loader";

// Manage order page class
class Addons extends Component {
  // Declare property values that belongs to the component
  state = {
    bread: [{ title: this.props.t("ADDONS"), url: "/assets" }],
    display: false,
    isMobile: false,
    showCustomerList: false,
    tenantList: [],
    tenant: "",
    addonsView: '',

    addonsFilters: {
      productName: "",
      addonId: "",
      orderId: "",
    },
    addonsHistoryPage: 1,
    addonsHistoryPerPage: 10,
    addonsHistoryStartRecord: 1,
    addonsRowsPerPage: 10,
    sortOrderAddons: "DESC",
    sortByAddons: "nonInventoriedAssetId",
    searchIdentifierValues: [],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    this.props.setCompDidMount();
    const addonsView = localStorage.getItem("addonsView");

    if (this.props.providerType === "SOLUTION_PROVIDER") {
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
        {},
      )
        .then((res) => {
          let list = res.data.tenants;
          var selectedSalesChannel = localStorage.getItem(
            "selectedSalesChannel",
          );
          this.setState(
            {
              tenantList: list,
              tenant:
                this.props.parentTenantId ||
                selectedSalesChannel ||
                (list && list.length > 0 ? list[0].tenantId : ""),
            },
            () => {
              localStorage.setItem(
                "selectedSalesChannel",
                this.state.tenant,
              );
              if (addonsView === null) {
                this.setState({
                  addonsView: 'detail'
                });
                // this.getCustomersHierarchy();
              } else {
                this.setState({
                  addonsView
                });
                this.getAddonsList();
              }
            },
          );
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.message
          ) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      if (addonsView === null) {
        this.setState({
          addonsView: 'detail'
        });
      } else {
        this.setState({
          addonsView
        });
        this.getAddonsList();
      }
    }
  }
  getAddonsList = () => {
    this.setState({
      loading: true,
    })
    let pageOptions = {
      batchSize: this.state.addonsRowsPerPage || 10,
      startRecord: this.state.addonsStartRecord || 1,
    };

    let filter = "&orderId=";
    if (this.state.addonsFilters.orderId !== null && this.state.addonsFilters.orderId !== "") {
      filter = filter + this.state.addonsFilters.orderId;
    }

    let data = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      data.tenantId = this.state.tenant;
    }

    let encodedSearchIdentifierValues = '';
    if (Array.isArray(this.state.searchIdentifierValues) && this.state.searchIdentifierValues.length > 0) {
      encodedSearchIdentifierValues = this.toBase64Json(this.state.searchIdentifierValues);
    }
    BusApiCall('GET', `${constants.busV44UrlPublic}/assets/addons?sortBy=${this.state.sortByAddons}&sortOrder=${this.state.sortOrderAddons}&productName=${this.state.addonsFilters.productName || ''}&id=${this.state.addonsFilters.addonId || ''}&orderId=${this.state.addonsFilters.orderId || ''}&customerName=${this.state.addonsFilters.customerName || ''}&jsonData=${encodedSearchIdentifierValues}`, data, pageOptions).then(res => {
      this.setState({
        addonsData: res.data || [],
        totalAddonsCount: +res.headers["x-total-count"],
        loading: false,
        searchingAddons: false,
      });
    })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, searchingAddons: false });
      });
  };

  updateAddonsSorting = (by) => {
    if (by === this.state.sortByAddons) {
      this.setState(
        {
          loading: true,
          sortOrderAddons: this.state.sortOrderAddons === "DESC" ? "ASC" : "DESC",
          addonsPage: 1,
          addonsStartRecord: 1,
        },
        () => {
          this.getAddonsList();
        },
      );
    } else {
      this.setState(
        {
          loading: true,
          sortByAddons: by,
          sortOrderAddons: "ASC",
          addonsHistoryPage: 1,
          addonsStartRecord: 1,
        },
        () => {
          this.getAddonsList();
        },
      );
    }
  };

  updateAddonsHistoryPerPageRows = (event) => {
    this.setState(
      {
        loading: true,
        addonsHistoryPage: 1,
        addonsHistoryPerPage: event.target.value,
        addonsHistoryStartRecord: 1,
      },
      () => {
        this.getAddonsList();
      },
    );
  };

  onAddonsHistoryPageChange = (e, page) => {
    this.setState(
      {
        loading: true,
        addonsHistoryPage: page,
        addonsHistoryStartRecord: this.state.addonsHistoryPerPage * (page - 1) + 1,
      },
      () => {
        this.getAddonsList();
      },
    );
  };

  onChangeAddonsInput = (e) => {
    var data = { ...this.state.addonsFilters };
    data[e.target.name] = e.target.value;
    this.setState({
      addonsFilters: data,
    });
  };
  onSearchKeyDownAddonsInput = (e) => {
    if (e.key === "Enter") {
      this.setState(
        {
          loading: true,
          addonsHistoryPage: 1,
          addonsHistoryStartRecord: 1,
        },
        () => {
          this.getAddonsList();
        },
      );
    }
  };

  handleSearchIdentifierAddonsChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => {
      const arr = Array.isArray(prev.searchIdentifierValues) ? [...prev.searchIdentifierValues] : [];
      const idx = arr.findIndex(item => item.key === name);
      if (value === '' || value == null) {
        if (idx > -1) arr.splice(idx, 1);
      } else if (idx > -1) {
        arr[idx] = { ...arr[idx], value };
      } else {
        arr.push({ key: name, value });
      }
      return { searchIdentifierValues: arr };
    });
  };

  filterAddonsTable = () => {
    this.setState(
      {
        loading: true,
        addonsHistoryPage: 1,
        addonsHistoryStartRecord: 1,
      },
      () => {
        this.getAddonsList();
      },
    );
  };

  clearAddonsTableSearch = () => {
    this.setState(
      {
        addonsFilters: {
          productName: "",
          addonId: "",
          orderId: "",
        },
        searchIdentifierValues: [],
        loading: true,
        addonsHistoryPage: 1,
        addonsHistoryStartRecord: 1,
      },
      () => {
        this.getAddonsList();
      },
    );
  };

  openAddon = (index) => {
    let addons = [...this.state.addonsData];
    if (
      !addons[index].expand &&
      !addons[index].addiotinalDetails
    ) {
      addons[index].expand = !addons[index].expand;
      this.setState({
        loading: true,
      });
      let jsonData = {};
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        jsonData.tenantId = this.state.tenant;
      }
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/addons/${addons[index].addonId}`,
        jsonData,
      )
        .then((res) => {
          addons[index].addiotinalDetails = res.data;
          this.setState({
            addonsData: addons,
            loading: false,
          });
        })
        .catch((err) => {
          this.setState({
            addonsData: addons,
            loading: false,
          });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      addons[index].expand = !addons[index].expand;
      this.setState({
        addonsData: addons,
      });
    }
  };

  toBase64Json(obj) {
    const json = JSON.stringify(obj);
    return btoa(unescape(encodeURIComponent(json)));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };

  changeRoute = (data) => {
    this.props.router.navigate("/newOrder", { state: data });
  };

  goToQuote = (id, type) => {
    if (type && type === "order") {
      this.props.router.navigate({
        pathname: "/order/" + id,
      });
    } else {
      this.props.router.navigate({
        pathname: "/quote/" + id,
      });
    }
  };
  toggleShowAllAddons = (viewType) => {
    this.setState({
      addonsView: viewType
    }, () => {
      if (viewType === 'list') {
        this.getAddonsList();
      }
    });
    localStorage.setItem("addonsView", viewType);
  }
  onChangeTenant = (e) => {
    this.setState({
      tenant: e.target.value,
    })
  }

  //clear addons filters
  clearAddonsFilters = () => {
    this.setState(
      {
        addonsFilters: {
          productName: "",
          addonId: "",
          orderId: "",
        },
        addonsPage: 1,
        addonsStartRecord: 1,
      },
      () => {
        this.getAddonsList();
      },
    );
  };
  
  onAddonsSearchKeyDownInput = (e) => {
    if (e.key === "Enter") {
      this.setState(
        {
          addonsPage: 1,
          addonsStartRecord: 1,
        },
        () => {
          this.getAddonsList();
        },
      );
    }
  };
  onChangeAddonsFilters = (e) => {
    var filters = { ...this.state.addonsFilters };
    filters[e.target.name] = e.target.value;
    this.setState({
      addonsFilters: filters,
    });
  };
  
  updateAddonsRowsPerPage = (event) => {
    this.setState(
      {
        addonsPage: 1,
        addonsStartRecord: 1,
        addonsRowsPerPage: event.target.value,
      },
      () => {
        this.getAddonsList();
      },
    );
  };
  changeAddonsPage = (event, newPage) => {
    this.setState(
      {
        addonsPage: newPage,
        addonsStartRecord: this.state.addonsRowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getAddonsList();
      },
    );
  };


  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              {isMobile && (
                <Grid
                  item
                  style={{ textAlign: "right" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
        <main>
          <Grid container spacing={1}>
            <Grid
              item
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "flex-end",
                marginBottom: "1rem",
              }}
              size={{
                xs: 12,
                md: 12,
              }}
            >
              {isMobile && (
                <Button
                  className="buttonSecondary"
                  onClick={this.toggleShowCustomerList}
                >
                  <span
                    style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                  >
                    <UsersIcon />
                  </span>
                  {t("SHOW_CUSTOMER_LIST")}
                </Button>
              )}
              <ButtonGroup variant="outlined">
                {/* DETAIL VIEW button */}
                <span
                  className={`buttonGroup ${this.state.addonsView === 'detail' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllAddons("detail")}
                  style={{
                    backgroundColor: this.state.addonsView === 'detail'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.addonsView === 'detail' ? "white" : "inherit",
                  }}
                >
                  <span style={{ marginRight: ".4rem" }}>
                    {this.props.t("DETAIL_VIEW")}
                  </span>
                  <DetailView />
                </span>
                {/* LIST VIEW button */}
                <span
                  className={`buttonGroup ${this.state.addonsView === 'list' ? "selected" : ""}`}
                  onClick={(e) => this.toggleShowAllAddons("list")}
                  style={{
                    backgroundColor: this.state.addonsView === 'list'
                      ? this.props.tenantData.color
                      : "inherit",
                    color: this.state.addonsView === 'list' ? "white" : "inherit",
                  }}
                >
                  <span>{this.props.t("LIST_VIEW")}</span>
                  <ListView />
                </span>
              </ButtonGroup>
            </Grid>
          </Grid>

          {this.state.addonsView === 'detail' ?
            <ManageCustomersHierarchy
              screen="addonsManagement"
              changeRoute={this.changeRoute}
              goToQuote={this.goToQuote}
              isMobile={isMobile}
              showCustomerList={showCustomerList}
              toggleShowCustomerList={this.toggleShowCustomerList}
            />
            :
            <>
              <AddonsTable
              screen='addonsManagement'
              subScreen='listView'
                totalAddonsCount={
                  this.state
                    .totalAddonsCount
                }
                addonsHistoryPage={
                  this.state.addonsHistoryPage
                }
                addonsHistoryPerPage={
                  this.state
                    .addonsHistoryPerPage
                }
                onAddonsHistoryPageChange={
                  this
                    .onAddonsHistoryPageChange
                }
                updateAddonsHistoryPerPageRows={
                  this
                    .updateAddonsHistoryPerPageRows
                }
                updateAddonsSorting={
                  this.updateAddonsSorting
                }
                data={
                  this.state
                    .addonsData
                }
                isChild={
                  this.state.showAddonItem
                    ? true
                    : false
                }
                customerDetails={
                  this.state.addonDetails
                }
                childItemDetails={
                  this.state
                    .addonDetails
                }
                openAddons={ 
                  this.openAddon
                }
                tenantId={this.state.tenant}
                getCustomerAddons={
                  this
                    .getAddonsList
                }
                searchingAddons={
                  this.state
                    .searchingAddons
                }
                changeRoute={
                  this.props.changeRoute
                }
                sortByAddons={
                  this.state.sortByAddons
                }
                sortOrderAddons={
                  this.state.sortOrderAddons
                }
                filters={
                  this.state.addonsFilters
                }
                clearAddonsTableSearch={
                  this.clearAddonsTableSearch
                }
                filterAddonsTable={
                  this.filterAddonsTable
                }
                onChangeAddonsInput={
                  this.onChangeAddonsInput
                }
                onSearchKeyDownAddonsInput={
                  this
                    .onSearchKeyDownAddonsInput
                }
                goToQuote={
                  this.goToQuote
                }
                expandItemHistory={
                  this.expandAddonHistory
                }
                handleSearchIdentifierAddonsChange={this.handleSearchIdentifierAddonsChange}
                searchIdentifierValues={this.state.searchIdentifierValues}

                onChangeAddonsFilters={
                  this.onChangeAddonsFilters
                }
                onAddonsSearchKeyDownInput={
                  this.onAddonsSearchKeyDownInput
                }
                clearAddonsFilters={
                  this.clearAddonsFilters
                }
                changeAddonsPage={
                  this.changeAddonsPage
                }
                updateAddonsRowsPerPage={
                  this.updateAddonsRowsPerPage
                }
                addonsRowsPerPage={
                  this.state.addonsRowsPerPage
                }
                addonsPage={
                  this.state.addonsPage
                }
                addonsStartRecord={
                  this.state.addonsStartRecord
                }
                tenantList={this.state.tenantList}
                onChangeTenant={this.onChangeTenant}
              />
            </>
          }
        </main>
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    menuPaths: state.auth.menuPaths,
    userPerms: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    showMyCustomers: state.auth.showMyCustomers,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Addons)));
